<template>
  <div class="address-form">
    <h2 class="title">
      <template v-if="!address.name">
        Добавить адрес доставки в городе
      </template>
      <template v-else>
        Редактировать адрес доставки в городе
      </template>

      <span @click="chooseCity">
        {{ innerAddress.cityName || USER_CITY.name }}
      </span>
    </h2>

    <div class="form">
      <div class="input address">
        <ui-input
          v-model="innerAddress.name"
          :autofocus="!address.name"
          placeholder="Например, «Офис» или «Дом»"
          label="Название адреса*"
          clearable
        />
      </div>

      <ui-metro
        class="input metro"
        v-model="innerAddress.metroStationId"
        :city-id="innerAddress.cityId || USER_CITY.id"
        @change="innerAddress.metroStationName = $event.name"
      />

      <div class="input street">
        <ui-street-suggest
          v-model="street"
          label="Улица*"
          :city-id="innerAddress.cityId || USER_CITY.id"
        />
      </div>

      <div class="input house">
        <ui-input
          v-model="innerAddress.house"
          placeholder="Номер дома"
          label="Дом*"
          validate="house"
          clearable
        />
      </div>

      <div class="input house-block half">
        <ui-input
          v-model="innerAddress.houseBlock"
          placeholder="Корпус"
          label="Корпус"
          validate="address_detail"
          clearable
        />
      </div>

      <div class="input building half">
        <ui-input
          v-model="innerAddress.building"
          label="Строение"
          placeholder="Строение"
          validate="address_detail"
          clearable
        />
      </div>

      <div
        class="input entrance half"
      >
        <ui-input
          v-model="innerAddress.entrance"
          label="Подъезд"
          placeholder="Подъезд"
          validate="entrance"
          clearable
        />
      </div>

      <div
        class="input floor half"
      >
        <ui-input
          v-model="innerAddress.floor"
          placeholder="Этаж"
          label="Этаж"
          validate="floor"
          clearable
        />
      </div>

      <div class="input apartment half">
        <ui-input
          v-model="innerAddress.apartment"
          placeholder="Квартира/ Офис"
          label="Квартира/ Офис"
          validate="address_detail"
          clearable
        />
      </div>

      <div class="input postcode half">
        <ui-input
          v-model="innerAddress.postalCode"
          placeholder="Индекс"
          mask="postalCode"
          label="Индекс"
          validate="postal_сode"
          clearable
        />
      </div>

      <div class="bottom">
        <ui-textarea
          class="comment"
          v-model="innerAddress.comment"
          placeholder="Комментарий к заказу"
        />

        <div
          v-if="changePrimary && !address.primary"
          class="checkbox"
        >
          <ui-checkbox
            v-model="innerAddress.primary"
            label="Сделать основным адресом для доставки"
          />
        </div>

        <ui-button
          :disabled="submitIsDisabled"
          :loading="loading"
          class="button"
          text="Сохранить"
          @click="save"
        />

        <ui-button
          secondary
          class="button"
          text="Отменить"
          @click="$emit('on-close')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'address-form',

  props: {
    address: {
      type: Object,
      require: true,
      default: () => {
      },
    },

    changePrimary: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      innerAddress: {...this.address},
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      USER_CITY: 'user/city'
    }),

    street: {
      get() {
        return {
          id: this.innerAddress.streetId || '',
          name: this.innerAddress.streetName || '',
        };
      },
      set({ id = '', name = '' } = {}) {
        this.innerAddress.streetName = name;
        this.innerAddress.streetId = id;
      },
    },

    submitIsDisabled() {
      return !this.innerAddress.name
        || !this.innerAddress.streetName
        || !this.innerAddress.house
        || JSON.stringify(this.address) === JSON.stringify(this.innerAddress);
    },
  },

  methods: {
    save() {
      if (!this.innerAddress?.cityId) this.innerAddress.cityId = this.USER_CITY.id; // актуально для создания нового адреса, когда города
                                                                                    // нет и не менялся пользователем,но обязан быть отправлен в форме
      this.loading = true;
      this[this.innerAddress.id ? 'updateAddress' : 'createAddress']().then(() => {
        this.$emit('success');
        this.loading = false;
      }).catch(e => {
        this.$store.dispatch('notifications/create', {
          message: e.response?.data,
        });
        this.loading = false;
      });
    },

    updateAddress() {
      return this.$store.$api.updateAddress({
        address: this.innerAddress,
      });
    },

    createAddress() {
      return this.$store.$api.createAddress({
        address: this.innerAddress,
      });
    },

    chooseCity() {
      this.$city.changeCity().then(city => {
        this.innerAddress.cityId = city.id;
        this.innerAddress.cityName = city.name;
        this.citySelectOpened = false;
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.address-form {
  & > .title {
    grid-area: title;
    font-size: 20px;
    line-height: 28px;

    & > span {
      color: $blue;
      cursor: pointer;
    }
  }

  .form {
    display: grid;
    /* stylelint-disable-next-line */
    grid-template-areas:
    "title title"
    "address address"
    "metro metro"
    "street street"
    "house house"
    "houseb building"
    "entrance floor"
    "apartment postcode"
    "bottom bottom";
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
    row-gap: 16px;
  }

  .form > .input {
    width: 100%;
    min-width: 0;

    input {
      max-width: 100%;
    }
  }

  .ui-input {
    min-height: 64px;
  }

  .address {
    grid-area: address;
  }

  .metro {
    grid-area: metro;
  }

  .street {
    grid-area: street;
  }

  .house {
    grid-area: house;
  }

  .house-block {
    grid-area: houseb;
  }

  .building {
    grid-area: building;
  }

  .entrance {
    grid-area: entrance;
  }

  .floor {
    grid-area: floor;
  }

  .apartment {
    grid-area: apartment;
  }

  .postcode {
    grid-area: postcode;
  }

  .bottom {
    grid-area: bottom;
    margin-top: 4px;
  }

  .checkbox {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .button {
    width: 100%;
    margin-top: 8px;
  }
}

@include breakpoint("tablet") {
  .address-form {
    .form {
      display: grid;
      /* stylelint-disable-next-line */
      grid-template-areas:
    "title title title title title title"
    "address address metro metro empty empty"
    "street street street street house house"
    "houseb building entrance floor apartment postcode"
    "bottom bottom bottom bottom bottom bottom";
      grid-template-columns: auto;
      column-gap: 16px;
      row-gap: 20px;
    }

    & > .title {
      width: 100%;
      font-size: 24px;
      line-height: 32px;
      padding-bottom: 16px;
      border-bottom: 1px solid $gray_lu;
    }

    .form > .input {
      margin-top: 0;
    }

    .address,
    .metro {
      margin-top: 4px;
    }

    .comment {
      width: 100%;
    }

    .half {
      margin-right: 16px;
    }

    .checkbox {
      width: 100%;
      margin-bottom: 0;
      order: 1;
    }

    .bottom {
      display: flex;
      flex-wrap: wrap;
    }

    .button {
      width: 113px;
      margin-top: 24px;
      margin-right: 16px;

      &:first-of-type {
        order: 3;
      }

      &:last-of-type {
        order: 2;
      }
    }
  }
}

@include breakpoint("desktop") {
  .address-form {
    .form {
      width: 912px;
      column-gap: 24px;
    }

    & > .title {
      font-size: 32px;
      line-height: 48px;
      padding-bottom: 24px;
    }

    .input {
      .ui-input {
        height: 40px;
      }
    }

    .address,
    .metro {
      margin-top: 10px;
    }

    .street,
    .house {
      margin-top: 12px;
    }

    .checkbox {
      margin-top: 32px;
    }

    .modal {
      & > .modal-content {
        width: auto;
        height: auto;
        padding: 24px;
        border-radius: 4px;
      }
    }

    .button {
      width: 123px;
      height: 56px;
      margin-top: 54px;
      font-size: 16px;
    }
  }
}
</style>
